import { formatterMoney } from "@/utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

const Columns = [
  {
    prop: "DealId",
    label: "No. Negociación",
    "min-width": "150",
    align: "center"
  },
  {
    prop: "Customer",
    label: "Cliente",
    "min-width": "300"
  },
  {
    prop: "Contact",
    label: "Contacto",
    "min-width": "200"
  },
  {
    prop: "SalesPerson",
    label: "Vendedor",
    "min-width": "200"
  },
  {
    prop: "Amount",
    label: "Monto",
    align: "center",
    "min-width": "150",
    formatter: (row) => formatterMoney(row.Amount)
  },
  {
    prop: "CloseDate",
    label: "Fecha de cierre",
    align: "center",
    "min-width": "150",
    formatter: DatetimeFormatter
  },
  {
    prop: "Phase",
    label: "Etapa",
    align: "center",
    "min-width": "100"
  },
  {
    prop: "RequiredAction",
    label: "Acción requerida",
    "min-width": "200"
  },
  {
    prop: "Request",
    label: "Solicitud acción requerida",
    "min-width": "200"
  },
  {
    prop: "Responsible",
    label: "Responsable Acción requerida",
    "min-width": "250"
  }
];

export { Columns };
